<!-- Footer -->
<section class="flex flex-auto justify-center w-full bg-accent-500 ">
    <footer class=" w-full sm:mb-0 dark:bg-slate-900">
        <div class="w-full sm:px-15">
            <!--Grid-->
            <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
                <!--End Col-->
                <div class="p-4">
                    <h1 class="text-xl font-semibold font-primary mb-2 uppercase text-white">subscribe</h1>
                    <div class="flex items-baseline md:justify-start sm:justify-center">
                        <span class="w-10 border-b-2 border-primary-500"></span>
                        <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                    </div>
                     <input id="email-address" name="email" type="email" autocomplete="email" required=""
                            class="min-w-0 flex-auto bg-white rounded-md border-0 px-3.5 py-2 mt-3 text-black shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-white sm:text-sm sm:leading-6"
                            placeholder="Enter your email">
                    <div class="flex flex-col items-center mt-4 lg:items-start">
                        <button type="submit"
                            class="h-11 py-3 px-6 bg-primary-600 transition-all duration-500 shadow-md text-sm text-white font-semibold w-fit hover:bg-primary-200 hover:text-primary-500">
                            Subscribe
                        </button>
                    </div>
                    <h1 class="text-xl font-semibold font-primary  uppercase text-white py-2">Availability</h1>
                    <div class="flex items-baseline md:justify-start sm:justify-center">
                        <span class="w-10 border-b-2 border-primary-500"></span>
                        <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                    </div>
                    <p class="text-white">Mon – Thurs: 08:30 – 17:00</p>
                    <p  class="text-white">Friday: 08:30 – 16:00</p>
                </div>
                <!--End Col-->
                <div class="w-full p-4 text-center lg:w-auto lg:text-left sm:order-last lg:order-none">
                    <h1 class="text-xl font-semibold font-primary mb-2 uppercase text-white">Navigation</h1>
                        <div class="flex items-baseline md:justify-start sm:justify-center">
                            <span class="w-10 border-b-2 border-primary-500"></span>
                            <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                        </div>
                    <ul class="mt-3">
                        <li class="transform transition-transform duration-300 hover:translate-x-2 hover:text-primary-500">
                            <a class="cursor-pointer text-white font-light text-sm" [routerLink]="'contact'">Contact Us</a>
                        </li>
                         <li class="transform transition-transform duration-300 hover:translate-x-2 hover:text-primary-500">
                            <a class="cursor-pointer text-white font-light text-sm" [routerLink]="'about-us'"> About Us</a>
                        </li>
                         <li class="transform transition-transform duration-300 hover:translate-x-2 hover:text-primary-500">
                            <a class="cursor-pointer text-white font-light text-sm" [routerLink]="'brochures'"> Brochures</a>
                        </li>
                         <li class="transform transition-transform duration-300 hover:translate-x-2 hover:text-primary-500">
                            <a class="cursor-pointer text-white font-light text-sm" [routerLink]="'blog'"> News Bulletins</a>
                        </li>
                        <li class="transform transition-transform duration-300 hover:translate-x-2 hover:text-primary-500">
                            <a class="cursor-pointer text-white font-light text-sm" [routerLink]="'blog'">Blog</a>
                        </li>
                    </ul>
                   
                    <div class="flex justify-center md:justify-start items-center mt-3">
                        <div><img class="w-20 p-2" src="assets/images/logo/ASATA2.png" alt="asata logo"></div>
                        <div><img class="w-20 p-2" src="assets/images/logo/IATA.jpeg" alt="iata logo"></div>
                    </div>
                </div>
                
                <!--End Col-->
                @if(view.site) {
                <fuse-card class="flex flex-col w-full  p-4 ">
                    <div class="flex flex-col">
                        <h1 class="text-xl uppercase font-semibold custom_font tracking-wide mb-2 dark:text-black">Contact Info</h1>
                        <div class="flex items-baseline">
                            <span class="w-10 border-b-2 border-primary-500"></span>
                            <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                        </div>
                    </div>
                    @if(view.site?.telephone) {
                    <div class="mt-2">
                        <h4 class="text-md font-semibold custom_font tracking-wide mb-2 dark:text-black">Phone Number:</h4>
                    </div>
                        <div class="flex items-center">
                            <div class="flex items-center">
                                <div
                                    class="flex items-center justify-center mr-5 w-8 h-8 bg-primary-500 border-none rounded-full">
                                    <mat-icon class="icon-size-5 text-white" [svgIcon]="'mat_solid:phone'"></mat-icon>
                                </div>
                                <div class="flex flex-col">
                                    <p class="dark:text-black text-sm">{{view.site?.telephone}}</p>
                                </div>
                            </div>
                        </div>
                    }
                    @if(view.site?.emailAddress) {
                        <div class="mt-2">
                            <h4 class="text-md font-semibold custom_font tracking-wide mb-2 dark:text-black">Email Address:</h4>
                        </div>
                        <div class="flex items-center ">
                            <div class="flex items-center">
                                <div
                                    class="flex items-center justify-center mr-5 w-8 h-8 bg-primary-500 border-none rounded-full">
                                    <mat-icon class="icon-size-5 text-white" [svgIcon]="'mat_solid:email'"></mat-icon>
                                </div>
                                <div class="flex flex-col">
                                    <p class="dark:text-black text-sm">{{view.site?.emailAddress}}</p>
                                </div>
                            </div>
                        </div>
                    }
                    @if(view.site.address) {
                        <div class="mt-2">
                            <h4 class="text-md font-semibold custom_font tracking-wide mb-2 dark:text-black">Location:</h4>
                        </div>
                        <div class="flex items-center ">
                            <div class="flex items-center">
                                <div
                                    class="flex items-center justify-center mr-5 w-8 h-8 bg-primary-500 border-none rounded-full">
                                    <mat-icon class="icon-size-5 text-white" [svgIcon]="'mat_solid:location_on'"></mat-icon>
                                </div>
                                <div class="flex flex-col">
                                    <p class="dark:text-black text-sm">{{view.site.address}}</p>
                                </div>
                            </div>
                        </div>
                    }
                </fuse-card>
                }
                <!--End Col-->
                <div class="mb-0 p-4 text-center">
                    <a class="flex justify-center md:justify-center" href="{{view.site?.website}}">
                        @if(view.site?.logoUrl2) {
                        <img [alt]="view.site?.name" [src]="view.site?.logoUrl" style="max-width: 150px;">
                        }
                    </a>
                    <div class="w-full text-center lg:w-auto lg:text-left">
                        <h1 class="text-xl uppercase font-semibold text-white my-4 text-center">Latest Cruise Specials</h1>
                        <p class="px-6 font-light text-white text-sm  text-center">Keep up to date with the latest deals and cruises by subscribing to our newsletter.</p>
                        @if (view.site?.profile.heading.border==1) {
                        <div class="flex items-baseline justify-center lg:justify-start">
                            <span class="w-10 border-b-2 border-primary-500"></span>
                            <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                        </div>
                        }
                      
                    </div>
                    <!-- <p class="py-8  text-gray-500 dark:text-white lg:max-w-xs text-center lg:text-left">{{view.site?.slogan}}</p> -->
                    <div class="flex justify-center p-1">
                        @if(view.site?.socialUrlFacebook) {
                        <a href="{{view.site?.socialUrlFacebook}}" target="_blank"
                            class="group relative w-8 h-8 m-2 rounded-full transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                [svgIcon]="'feather:facebook'"></mat-icon>
                        </a>
                        }
                        @if(view.site?.socialUrlInstagram) {
                        <a href="{{view.site?.socialUrlInstagram}}" target="_blank"
                            class="group relative w-8 h-8 m-2 rounded-full transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                [svgIcon]="'feather:instagram'"></mat-icon>
                        </a>
                        }
                        @if(view.site?.socialUrlLinkedIn) {
                        <a href="{{view.site?.socialUrlLinkedIn}}" target="_blank"
                            class="group relative w-8 h-8 m-2 rounded-full transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                [svgIcon]="'feather:linkedin'"></mat-icon>
                        </a>
                        }
                    </div>
                </div>
            </div>
            <!--Grid-->
            <div class="py-7 border-t border-gray-200">
                <div class="flex items-center justify-center flex-col lg:justify-between lg:flex-row">
                    <p class="text-sm text-gray-500 dark:text-white">© Copyright &copy; {{currentYear}} <span class="mx-1 text-primary-500">TravelFind.Me</span>(Pty) Ltd. All rights reserved.</p>
                    @if(view.pages) {
                        <ul class="flex items-center gap-9 mt-4 lg:mt-0">
                        @for(page of view.pages; track page) {
                        <li><a [routerLink]="['/policy', page.seo.alias]" class="text-sm text-gray-500 dark:text-white hover:text-primary-500">{{page.name}}</a></li>
                        }
                        <li><a href="https://xltravel.co.za/PAIA%20Manual%20Template%20updated%20JS%2022%20June%202021%20-%2025%20June%202021.pdf" target="_blank" class="text-sm text-gray-500 dark:text-white hover:text-primary-500">PAIA Manual</a></li>
                    </ul>
                    }
                </div>
            </div>
            
        </div>
    </footer>
</section>